module.exports = __webpack_public_path__ + "static/media/highlighter.66fd3373.svg";